"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.innerGetDeploymentOperations = exports.innerGetDeploymentError = void 0;
const tslib_1 = require("tslib");
const pageSize = 100;
async function innerGetDeploymentError(client, resourceGroupName, deploymentName) {
    return client.deployments.get(resourceGroupName, deploymentName);
}
exports.innerGetDeploymentError = innerGetDeploymentError;
async function innerGetDeploymentOperations(client, resourceGroupName, deploymentName) {
    var e_1, _a;
    const res = [];
    try {
        for (var _b = tslib_1.__asyncValues(client.deploymentOperations
            .list(resourceGroupName, deploymentName)
            .byPage({ maxPageSize: pageSize })), _c; _c = await _b.next(), !_c.done;) {
            const page = _c.value;
            res.push(...page);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) await _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return res;
}
exports.innerGetDeploymentOperations = innerGetDeploymentOperations;
//# sourceMappingURL=innerHandleError.js.map